import {AxiosRequestConfig, AxiosResponse} from 'axios'
import {REDUX_STORE} from '../lib/redux/ReduxStore'

export function handleRequestOnFulfilled(request: AxiosRequestConfig) {
  const token = REDUX_STORE.getState().user?.token

  if (token && request.headers) {
    request.headers.Authorization = `Bearer ${token}`
  }

  return request
}

export function handleServiceResponseInterceptor(response: AxiosResponse) {
  return response
}
